module.exports = "https://statics.teams.cdn.live.net/hashedassets-launcher/v2/reload.136eb682297941c229ab80b268e1d265.svg";